module.exports = __webpack_public_path__ + "img/patesfines.f757841f.png";